import { Component, inject, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import { UserManagementService } from "../../services/user-management.service";
import { StorageService } from "../../services/storage.service";
import { AuthUserProfile } from "../../store/entities/uaa/auth-user.model";
import { Apollo } from 'apollo-angular';
import { CHECK_GAZETI_ACCESS } from "../../modules/main-landing-page/landing.graphql";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit, OnDestroy {
  private fb: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private notificationService: NotificationService = inject(NotificationService);
  private router: Router = inject(Router);
  private uaaService: UserManagementService = inject(UserManagementService);
  private storageService = inject(StorageService);
  private apollo: Apollo = inject(Apollo);
  private location = inject(Location)

  form: FormGroup;
  slides = [
    { image: "assets/images/news1.png", text: "Explore Legal and Public Announcements From Government" },
    { image: "assets/images/news2.png", text: "Explore Your Digital Source of Government Information" },
  ];
  currentIndex = 0;
  interval: any;
  hide = true;
  loading = false;
  otpSent = false;
  loginMode: 'PASSWORD' | 'OTP' = 'PASSWORD';
  savedPhoneNumber: string = '';

  ngOnInit() {
    this.form = this.fb.group({
      username: [null],
      password: [null],
      phoneNumber: [null],
      otp: [null],
    });

    // Default → password login
    this.enablePasswordLogin();

    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 3000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
  goBack() {
    this.router.navigate(['/landing']);
  }

  enablePasswordLogin() {
    this.loginMode = 'PASSWORD';
    this.otpSent = false;
    this.savedPhoneNumber = '';

    this.form.get('username')?.setValidators([Validators.required, Validators.email]);
    this.form.get('password')?.setValidators([Validators.required]);

    this.form.get('phoneNumber')?.clearValidators();
    this.form.get('otp')?.clearValidators();

    this.form.reset();
    this.form.updateValueAndValidity();
  }

  async networkLogin() {
    this.loading = true;
    try {
      const authTokenModel = await this.authService.networkLogin();
      if (!authTokenModel?.accessToken) {
        this.notificationService.errorMessage("Invalid username or password");
        this.loading = false;
        return;
      }
      this.storageService.set("accessToken", authTokenModel.accessToken);
      //const authUser = await this.loadUserProfile();
      // if (!authUser) {
      //   this.notificationService.errorMessage("Failed to load user profile");
      //   this.loading = false;
      //   return;
      // }
      // const userType = (authUser.userType || "").trim().toUpperCase();
      // const isStaffOrAdmin = userType === "STAFF" || userType === "ADMIN";
      const intendedGazetiUuid: string | null = (history.state as any)?.intendedGazetiUuid || null;


      // if (isStaffOrAdmin) {
      //   if (intendedGazetiUuid) {
      //     await this.router.navigate(['/innerlanding']);
      //   } else {
      await this.router.navigate(['/innerlanding']);
      //   }
      //   return;
      // }


      if (intendedGazetiUuid) {
        try {
          const result = await this.apollo.query<{
            checkGazetiAccess: {
              response: { status: boolean; message: string };
              data: { hasSubscription: boolean; hasAccess: boolean; message?: string };
            };
          }>({
            query: CHECK_GAZETI_ACCESS,
            variables: { gazetiUuid: intendedGazetiUuid },
            fetchPolicy: 'network-only',
          }).toPromise();

          const accessData = result.data?.checkGazetiAccess;
          if (accessData?.response?.status && accessData.data?.hasSubscription) {
            await this.router.navigate(['/gazeti-preview', intendedGazetiUuid]);
          } else {
            await this.router.navigate(['/subscription'], {
              state: { intendedGazetiUuid }
            });
          }
        } catch (err: any) {
          console.error("Error checking gazeti access:", err);
          await this.router.navigate(['/subscription'], {
            state: { intendedGazetiUuid }
          });
        }
      } else {

        //if (userType === "CORPORATE" || userType === "PERSONAL") {
        await this.router.navigate(['/corporate']);
        // } else {

        await this.router.navigate(['/subscription']);
        //}
      }
    } catch (e: any) {
      this.notificationService.errorMessage(
        e?.error?.message || e?.message || "Invalid username or password"
      );
    } finally {
      this.loading = false;
    }
  }





  enableOtpLogin() {
    this.loginMode = 'OTP';
    this.otpSent = false;
    this.savedPhoneNumber = '';

    this.form.get('phoneNumber')?.setValidators([
      Validators.required,
      Validators.pattern('^[0-9]{9,15}$')
    ]);

    this.form.get('username')?.clearValidators();
    this.form.get('password')?.clearValidators();
    this.form.get('otp')?.clearValidators();

    this.form.reset();
    this.form.updateValueAndValidity();
  }

  private async loadUserProfile(): Promise<AuthUserProfile | null> {
    try {
      const authUser = await this.uaaService.getUserProfileAndRoles();
      console.log("User profile loaded", authUser);
      return authUser;
    } catch (error: any) {
      this.notificationService.errorMessage(error?.message || "Failed to load user profile");
      return null;
    }
  }

  async login(formValue: any) {
    this.loading = true;
    try {
      const authTokenModel = await this.authService.login(formValue);
      if (!authTokenModel?.accessToken) {
        this.notificationService.errorMessage("Invalid username or password");
        this.loading = false;
        return;
      }
      this.storageService.set("accessToken", authTokenModel.accessToken);
      const authUser = await this.loadUserProfile();
      if (!authUser) {
        this.notificationService.errorMessage("Failed to load user profile");
        this.loading = false;
        return;
      }
      const userType = (authUser.userType || "").trim().toUpperCase();
      const isStaffOrAdmin = userType === "STAFF" || userType === "ADMIN";
      const intendedGazetiUuid: string | null = (history.state as any)?.intendedGazetiUuid || null;


      if (isStaffOrAdmin) {
        if (intendedGazetiUuid) {
          await this.router.navigate(['/innerlanding']);
        } else {
          await this.router.navigate(['/innerlanding']);
        }
        return;
      }


      if (intendedGazetiUuid) {
        try {
          const result = await this.apollo.query<{
            checkGazetiAccess: {
              response: { status: boolean; message: string };
              data: { hasSubscription: boolean; hasAccess: boolean; message?: string };
            };
          }>({
            query: CHECK_GAZETI_ACCESS,
            variables: { gazetiUuid: intendedGazetiUuid },
            fetchPolicy: 'network-only',
          }).toPromise();

          const accessData = result.data?.checkGazetiAccess;
          if (accessData?.response?.status && accessData.data?.hasSubscription) {
            await this.router.navigate(['/gazeti-preview', intendedGazetiUuid]);
          } else {
            await this.router.navigate(['/subscription'], {
              state: { intendedGazetiUuid }
            });
          }
        } catch (err: any) {
          console.error("Error checking gazeti access:", err);
          await this.router.navigate(['/subscription'], {
            state: { intendedGazetiUuid }
          });
        }
      } else {

        if (userType === "CORPORATE" || userType === "PERSONAL") {
          await this.router.navigate(['/corporate']);
        } else {

          await this.router.navigate(['/subscription']);
        }
      }
    } catch (e: any) {
      this.notificationService.errorMessage(
        e?.error?.message || e?.message || "Invalid username or password"
      );
    } finally {
      this.loading = false;
    }
  }

  async generateOtp() {
    if (this.form.get('phoneNumber')?.invalid) {
      this.notificationService.errorMessage('Enter valid phone number');
      return;
    }

    this.loading = true;
    try {
      const phoneNumber = this.form.value.phoneNumber;
      await this.authService.generateOtp(phoneNumber);


      this.savedPhoneNumber = phoneNumber;
      this.otpSent = true;

      // Set OTP field as required
      this.form.get('otp')?.setValidators([Validators.required, Validators.pattern('^[0-9]{6}$')]);
      this.form.get('otp')?.updateValueAndValidity();

      this.notificationService.successMessage('OTP sent successfully to ' + phoneNumber);
    } catch (e: any) {
      this.notificationService.errorMessage(
        e?.error?.message || 'Failed to send OTP'
      );
    } finally {
      this.loading = false;
    }
  }

  async verifyOtpAndLogin() {
    if (this.form.get('otp')?.invalid) {
      this.notificationService.errorMessage('Enter valid 6-digit OTP');
      return;
    }

    if (!this.savedPhoneNumber) {
      this.notificationService.errorMessage('Phone number not found. Please regenerate OTP.');
      this.resetOtpFlow();
      return;
    }

    this.loading = true;
    try {
      // Send both saved phone number and OTP for verification
      const token = await this.authService.verifyOtp(
        this.savedPhoneNumber,
        this.form.value.otp
      );
      console.log(token)
      if (!token) {
        this.notificationService.errorMessage('OTP verification failed');
        return;
      }

      if (!token.accessToken) {
        this.notificationService.errorMessage('Authentication failed');
        return;
      }



      // Load user profile and navigate
      const authUser = await this.loadUserProfile();
      if (!authUser) return;

      await this.handleNavigation(authUser);
    } catch (e: any) {
      this.notificationService.errorMessage(
        e?.error?.message || 'OTP verification failed'
      );
    } finally {
      this.loading = false;
    }
  }

  resetOtpFlow() {
    this.otpSent = false;
    this.savedPhoneNumber = '';
    this.form.get('otp')?.reset();
    this.form.get('otp')?.clearValidators();
    this.form.get('otp')?.updateValueAndValidity();
  }

  private async handleNavigation(authUser: AuthUserProfile) {
    const userType = (authUser.userType || "").trim().toUpperCase();
    const isStaffOrAdmin = userType === 'STAFF' || userType === 'ADMIN';
    const intendedGazetiUuid = (history.state as any)?.intendedGazetiUuid || null;

    // STAFF/ADMIN: Always go to dashboard
    if (isStaffOrAdmin) {
      await this.router.navigate(['/innerlanding']);
      return;
    }

    // REGULAR USERS: Handle gazeti intent and subscription check
    if (intendedGazetiUuid) {
      try {
        const result = await this.apollo.query<{
          checkGazetiAccess: {
            response: { status: boolean; message: string };
            data: { hasSubscription: boolean; hasAccess: boolean; message?: string };
          };
        }>({
          query: CHECK_GAZETI_ACCESS,
          variables: { gazetiUuid: intendedGazetiUuid },
          fetchPolicy: 'network-only',
        }).toPromise();

        const accessData = result.data?.checkGazetiAccess;

        if (accessData?.response?.status && accessData.data?.hasSubscription) {
          await this.router.navigate(['/gazeti-magazine', intendedGazetiUuid]);
        } else {
          await this.router.navigate(['/subscription'], {
            state: { intendedGazetiUuid }
          });
        }
      } catch (err: any) {
        console.error("Error checking gazeti access:", err);
        await this.router.navigate(['/subscription'], {
          state: { intendedGazetiUuid }
        });
      }
    } else {
      await this.router.navigate(['/subscription']);
    }
  }

  async onGoogleSocialLogin() {
    this.loading = true;

    try {
      const tokenDetails: any = await (this.authService.loginWithGoogle() as any);

      console.log("Google token details:", tokenDetails);

      if (!tokenDetails || !tokenDetails.accessToken) {
        this.notificationService.errorMessage('Google login failed');
        this.loading = false;
        return;
      }

      const authUser = await this.loadUserProfile();

      if (!authUser) {
        this.notificationService.errorMessage("Failed to load user profile");
        this.loading = false;
        return;
      }

      await this.handleNavigation(authUser);
    } catch (e: any) {
      this.notificationService.errorMessage(
        e?.error?.message || e?.message || "Google login failed"
      );
    } finally {
      this.loading = false;
    }
  }

  prev() {
    this.currentIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }
}
